import { useEffect } from 'react'
import { useShopify } from '../contexts/shopify'
import { getSessionStorageSizeVariantKey } from '../utils'

export const useSizeVariantHydration = () => {
  const { setSizeVariants, sizeVariants } = useShopify()

  const sessionVariants =
    JSON.parse(sessionStorage.getItem(getSessionStorageSizeVariantKey())) || {}

  useEffect(() => {
    if (
      Object.keys(sessionVariants).length !== Object.keys(sizeVariants).length
    ) {
      setSizeVariants(sessionVariants || {})
    }
  }, [sessionVariants])
}
